import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import picnicAtLake from  './images/picnic-at-lake.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    sectionId='quiz-callout-income-annuities'
    moduleName='quiz-callout-module'
    moduleVariation='A'
    // theming
    themeType='darkTheme'
    backgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    calloutBackgroundVariant='darkDefault'
    // configs
    disableLazyLoad
    isFullWidth
    withBGImage
    withHoverShadow={false}
    // content
    imageUrl={picnicAtLake.toString()}
    headingText={
      <>
        <Typography
          component='span'
          themeType='darkTheme'>
          How does an <WidowBlock>annuity work&#63;</WidowBlock>
        </Typography>
        <Typography
          component='span'
          themeType='darkTheme'
          block>
          Test your knowledge.
        </Typography>
      </>
    }
    buttonText='Take our quiz'
    linkUrl='/life-and-money/quiz/how-does-an-annuity-work-test-your-knowledge/'
    ariaLabel='Use our calculator to see what annuity is right for you.'
  />
);
